// CSV renderer — walks the resolved sections array and downloads a single
// RFC 4180 file with a metadata block and one blank line between sections.
import { csvValue, downloadBlob } from './exportUtils';

const GRANULARITY_LABELS = {
  day: 'Daily',
  week: 'Weekly',
  month: 'Monthly',
  all: 'Full Run',
};

// Quote a field only when needed; double embedded quotes. 0 stays '0'.
const escapeCsv = (value) => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const slug = (str) => String(str)
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const generateCSV = ({ sections, meta }) => {
  const lines = [];

  // Metadata block
  lines.push(['Title', meta.title].map(escapeCsv).join(','));
  lines.push(['Company', meta.companyName].map(escapeCsv).join(','));
  lines.push(['Period', meta.dateRangeLabel].map(escapeCsv).join(','));
  lines.push(['Generated', meta.generatedAt].map(escapeCsv).join(','));
  if (meta.granularity) {
    lines.push(['Granularity', GRANULARITY_LABELS[meta.granularity] || meta.granularity].map(escapeCsv).join(','));
  }

  sections.forEach((section) => {
    lines.push('');
    lines.push(escapeCsv(section.label));
    if (section.type === 'metrics') {
      lines.push('Metric,Value');
      section.metrics.forEach((m) => {
        lines.push([escapeCsv(m.label), escapeCsv(csvValue(m.value, m.type))].join(','));
      });
    } else {
      lines.push(section.columns.map((c) => escapeCsv(c.header)).join(','));
      section.rows.forEach((row) => {
        lines.push(section.columns.map((c) => escapeCsv(csvValue(c.get(row), c.type))).join(','));
      });
    }
  });

  const csv = `\ufeff${lines.join('\r\n')}\r\n`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const date = new Date().toISOString().split('T')[0];
  downloadBlob(`${slug(meta.companyName)}_${slug(meta.pageTypeLabel)}_${date}.csv`, blob);
};
